export const mockResponse = 
    {
      "statusCode":0,
      "data": {
      "cacheExpiryTime": 320,
      "pages": 1,
      "pageIndex": 0,
      "scrubber": 0,
      "configs": {
      "ribbons": {
      "PREORDER": {
      "type": "PREORDER",
      "text": "Preorder",
      "textColor": "#ffffff",
      "imageId": "sfefefefeegeg",
      "topBackgroundColor": "#d53d4c",
      "bottomBackgroundColor": "#af2330",
      "priority": 3
      },
      "EXCLUSIVE": {
      "type": "EXCLUSIVE",
      "text": "Exclusive",
      "textColor": "#ffffff",
      "imageId": "sfefefefeegeg",
      "topBackgroundColor": "#fa4a5b",
      "bottomBackgroundColor": "#d12a3b",
      "priority": 2
      },
      "NEW": {
      "type": "NEW",
      "text": "Newly Added",
      "textColor": "#ffffff",
      "imageId": "sfefefefeegeg",
      "topBackgroundColor": "#d53d4c",
      "bottomBackgroundColor": "#af2330",
      "priority": 4
      },
      "REPEAT": {
      "type": "REPEAT",
      "text": "Repeat",
      "textColor": "#ffffff",
      "imageId": "sfefefefeegeg",
      "topBackgroundColor": "#D53D4C",
      "bottomBackgroundColor": "#B02331",
      "priority": 6
      },
      "CLOUD": {
      "type": "CLOUD",
      "text": "Daily Menus",
      "textColor": "#ffffff",
      "imageId": "sfefefefeegeg",
      "topBackgroundColor": "#fa4a5b",
      "bottomBackgroundColor": "#d12a3b",
      "priority": 5
      },
      "PREMIUM": {
      "type": "PREMIUM",
      "text": "Premium",
      "textColor": "#ffffff",
      "imageId": "sfefefefeegeg",
      "topBackgroundColor": "#8a584b",
      "bottomBackgroundColor": "#583229",
      "priority": 7
      },
      "PROMOTED": {
      "type": "PROMOTED",
      "text": "Promoted",
      "textColor": "#ffffff",
      "imageId": "sfefefefeegeg",
      "topBackgroundColor": "#3a3c41",
      "bottomBackgroundColor": "#1e2023",
      "priority": 1
      }
      },
      "croutons": {
      "RAIN": {
      "type": "Crouton",
      "bgColor": "#282C3F",
      "icon": "surge_listing_piuzrv",
      "textColor": "#ffffff",
      "title": "Bad Weather",
      "message": "${amount} extra levied on some restaurants"
      },
      "RAIN_DEFAULT": {
      "type": "Crouton",
      "bgColor": "#282C3F",
      "icon": "surge_listing_piuzrv",
      "textColor": "#ffffff",
      "title": "Bad Weather",
      "message": "Your orders may be delayed by 5-10 mins"
      },
      "SERVICEABLE_WITH_BANNER_RAIN": {
      "type": "Crouton",
      "bgColor": "#282C3F",
      "icon": "rain_crouton_4x",
      "textColor": "#ffffff",
      "title": "Bad Weather",
      "message": "Few restaurants unserviceable due to rains"
      },
      "RAIN_LOW": {
      "type": "Crouton",
      "bgColor": "#282C3F",
      "icon": "surge_listing_piuzrv",
      "textColor": "#ffffff",
      "title": "Bad Weather",
      "message": "Your orders may be delayed by 5-10 mins"
      },
      "RAIN_HIGH": {
      "type" : "Crouton",
      "bgColor": "#282C3F",
      "icon": "surge_listing_piuzrv",
      "textColor": "#ffffff",
      "title": "Bad Weather",
      "message": "Your orders may be delayed by 5-10 mins"
      },
      "SPECIAL": {
      "type": "Crouton",
      "bgColor": "#282C3F",
      "icon": "surge_listing_piuzrv",
      "textColor": "#ffffff",
      "title": "High Demand",
      "message": "Surge fee of Rs ${amount} may be applicable"
      }
      }
      },
      "totalSize": "1488",
      "currentOffset": "31",
      "cards": [
      {
      "cardType": "restaurant",
      "layoutAlignmentType": "VERTICAL",
      "data": {
      "type": "restaurant",
      "data": {
      "type": "F",
      "id": "391071",
      "name": "Tawakkal mubarak hotel",
      "uuid": "3c6e8944-817a-4846-bb04-3d958ee0b855",
      "city": "1",
      "area": "CV Raman Nagar",
      "totalRatingsString": "1000+ ratings",
      "cloudinaryImageId": "dg9q5qsjldskbjokz4di",
      "cuisines": [
      "Indian",
      "Biryani"
      ],
      "tags": [],
      "costForTwo": 50000,
      "costForTwoString": "₹500 FOR TWO",
      "deliveryTime": 31,
      "minDeliveryTime": 31,
      "maxDeliveryTime": 31,
      "slaString": "31 MINS",
      "lastMileTravel": 6.5,
      "slugs": {
      "restaurant": "tawakkal-mubarak-hotel-cv-raman-nagar-cv-raman-nagar",
      "city": "bangalore"
      },
      "cityState": "1",
      "address": "26/1 GUJRI LANE ISLAMPUR VIMANAPURA H A L",
      "locality": "Vimanapura",
      "parentId": 256917,
      "unserviceable": false,
      "veg": false,
      "select": false,
      "favorite": false,
      "tradeCampaignHeaders": [],
      "chain": [],
      "feeDetails": {
      "fees": [
      {
      "name": "distance",
      "fee": 6300,
      "message": ""
      },
      {
      "name": "time",
      "fee": 0,
      "message": ""
      },
      {
      "name": "special",
      "fee": 0,
      "message": ""
      }
      ],
      "totalFees": 6300,
      "message": "",
      "title": "Delivery Charge",
      "amount": "6300",
      "icon": ""
      },
      "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
      },
      "longDistanceEnabled": 0,
      "rainMode": "NONE",
      "thirdPartyAddress": false,
      "thirdPartyVendor": "",
      "adTrackingID": "",
      "badges": {
      "imageBased": [],
      "textBased": [],
      "textExtendedBadges": []
      },
      "lastMileTravelString": "6.5 kms",
      "hasSurge": false,
      "aggregatedDiscountInfoV3": {
      "header": "₹100 OFF",
      "subHeader": "ABOVE ₹599",
      "discountTag": "FLAT DEAL",
      "headerTypeV2": 0
      },
      "sla": {
      "restaurantId": "391071",
      "deliveryTime": 31,
      "minDeliveryTime": 31,
      "maxDeliveryTime": 31,
      "lastMileTravel": 6.5,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
      },
      "promoted": false,
      "avgRating": "3.8",
      "totalRatings": 1000,
      "new": false
      },
      "subtype": "basic"
      },
      "parentWidget": false
      },
      {
      "cardType": "restaurant",
      "layoutAlignmentType": "VERTICAL",
      "data": {
      "type": "restaurant",
      "data": {
      "type": "F",
      "id": "32398",
      "name": "The Bowl Company",
      "uuid": "0af24804-6a70-4a98-b733-bc1efdeb3402",
      "city": "1",
      "area": "Marathahalli",
      "totalRatingsString": "10000+ ratings",
      "cloudinaryImageId": "bb6049fae59b8a2413a9177eb0338b49",
      "cuisines": [
      "Pan-Asian",
      "Continental",
      "North Indian",
      "Desserts",
      "American",
      "Asian",
      "Beverages",
      "Biryani",
      "Chinese",
      "European",
      "Grill",
      "Hyderabadi",
      "Indian",
      "Italian",
      "Kebabs",
      "Lucknowi",
      "Mediterranean",
      "Mexican",
      "Mughlai",
      "Oriental",
      "Pastas",
      "Punjabi",
      "Raja"
      ],
      "tags": [],
      "costForTwo": 30000,
      "costForTwoString": "₹300 FOR TWO",
      "deliveryTime": 26,
      "minDeliveryTime": 26,
      "maxDeliveryTime": 26,
      "slaString": "26 MINS",
      "lastMileTravel": 4.300000190734863,
      "slugs": {
      "restaurant": "the-bowl-company-marathahalli",
      "city": "bangalore"
      },
      "cityState": "1",
      "address": "sai tower,1st floor munnekolala varthur hobli,maratahalli,bangalore-560036",
      "locality": "Munnekollal",
      "parentId": 4317,
      "unserviceable": false,
      "veg": false,
      "select": false,
      "favorite": false,
      "tradeCampaignHeaders": [],
      "chain": [],
      "feeDetails": {
      "fees": [
      {
      "name": "distance",
      "fee": 4000,
      "message": ""
      },
      {
      "name": "time",
      "fee": 0,
      "message": ""
      },
      {
      "name": "special",
      "fee": 0,
      "message": ""
      }
      ],
      "totalFees": 4000,
      "message": "",
      "title": "Delivery Charge",
      "amount": "4000",
      "icon": ""
      },
      "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
      },
      "longDistanceEnabled": 0,
      "rainMode": "NONE",
      "thirdPartyAddress": false,
      "thirdPartyVendor": "",
      "adTrackingID": "",
      "badges": {
      "imageBased": [],
      "textBased": [],
      "textExtendedBadges": []
      },
      "lastMileTravelString": "4.3 kms",
      "hasSurge": false,
      "aggregatedDiscountInfoV3": {
      "header": "60% OFF",
      "subHeader": "UPTO ₹100",
      "discountTag": "",
      "headerTypeV2": 0
      },
      "sla": {
      "restaurantId": "32398",
      "deliveryTime": 26,
      "minDeliveryTime": 26,
      "maxDeliveryTime": 26,
      "lastMileTravel": 4.300000190734863,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
      },
      "promoted": false,
      "avgRating": "4.3",
      "totalRatings": 10000,
      "new": false
      },
      "subtype": "basic"
      },
      "parentWidget": false
      },
      {
      "cardType": "restaurant",
      "layoutAlignmentType": "VERTICAL",
      "data": {
      "type": "restaurant",
      "data": {
      "type": "F",
      "id": "451890",
      "name": "Moriz Whitefield",
      "uuid": "225a009d-098a-4e78-82f6-cf5a38e94de2",
      "city": "1",
      "area": "Whitefield",
      "totalRatingsString": "1000+ ratings",
      "cloudinaryImageId": "2ace92edd59d3477827682b5f7f9100f",
      "cuisines": [
      "Arabian",
      "Biryani",
      "Indian",
      "Chinese",
      "Tandoor",
      "Desserts"
      ],
      "tags": [],
      "costForTwo": 30000,
      "costForTwoString": "₹300 FOR TWO",
      "deliveryTime": 33,
      "minDeliveryTime": 33,
      "maxDeliveryTime": 33,
      "slaString": "33 MINS",
      "lastMileTravel": 6.599999904632568,
      "slugs": {
      "restaurant": "moriz-whitefield-whitefield-whitefield",
      "city": "bangalore"
      },
      "cityState": "1",
      "address": "Shop No. 104, Opp. Greenwood High Pre School, Narayanappa Garden, Whitefield, Bengaluru - 560066",
      "locality": "Narayanappa Garden",
      "parentId": 271708,
      "unserviceable": false,
      "veg": false,
      "select": false,
      "favorite": false,
      "tradeCampaignHeaders": [],
      "chain": [],
      "feeDetails": {
      "fees": [
      {
      "name": "distance",
      "fee": 6300,
      "message": ""
      },
      {
      "name": "time",
      "fee": 0,
      "message": ""
      },
      {
      "name": "special",
      "fee": 0,
      "message": ""
      }
      ],
      "totalFees": 6300,
      "message": "",
      "title": "Delivery Charge",
      "amount": "6300",
      "icon": ""
      },
      "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
      },
      "longDistanceEnabled": 0,
      "rainMode": "NONE",
      "thirdPartyAddress": false,
      "thirdPartyVendor": "",
      "adTrackingID": "",
      "badges": {
      "imageBased": [],
      "textBased": [],
      "textExtendedBadges": []
      },
      "lastMileTravelString": "6.5 kms",
      "hasSurge": false,
      "aggregatedDiscountInfoV3": {
      "header": "30% OFF",
      "subHeader": "UPTO ₹75",
      "discountTag": "",
      "headerTypeV2": 0
      },
      "sla": {
      "restaurantId": "451890",
      "deliveryTime": 33,
      "minDeliveryTime": 33,
      "maxDeliveryTime": 33,
      "lastMileTravel": 6.599999904632568,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
      },
      "promoted": false,
      "avgRating": "3.8",
      "totalRatings": 1000,
      "new": false
      },
      "subtype": "basic"
      },
      "parentWidget": false
      },
      {
      "cardType": "restaurant",
      "layoutAlignmentType": "VERTICAL",
      "data": {
      "type": "restaurant",
      "data": {
      "type": "F",
      "id": "256960",
      "name": "Shanmukha Restaurant",
      "uuid": "f31cc794-8f6b-4a10-92c5-72d2c6e87c51",
      "city": "1",
      "area": "Brookefield",
      "totalRatingsString": "1000+ ratings",
      "cloudinaryImageId": "abcktugmzdvmc8cvaxre",
      "cuisines": [
      "Biryani",
      "Andhra",
      "South Indian",
      "North Indian",
      "Tandoor",
      "Chinese",
      "Beverages",
      "Desserts"
      ],
      "tags": [],
      "costForTwo": 30000,
      "costForTwoString": "₹300 FOR TWO",
      "deliveryTime": 18,
      "minDeliveryTime": 18,
      "maxDeliveryTime": 18,
      "slaString": "18 MINS",
      "lastMileTravel": 1.100000023841858,
      "slugs": {
      "restaurant": "shanmukha-restaurant-whitefield-whitefield",
      "city": "bangalore"
      },
      "cityState": "1",
      "address": "Kundalahalli, Brookefield, Bengaluru, Karnataka 560037, India",
      "locality": "Kundalahalli",
      "parentId": 9954,
      "unserviceable": false,
      "veg": false,
      "select": false,
      "favorite": false,
      "tradeCampaignHeaders": [],
      "chain": [],
      "feeDetails": {
      "fees": [
      {
      "name": "distance",
      "fee": 3000,
      "message": ""
      },
      {
      "name": "time",
      "fee": 0,
      "message": ""
      },
      {
      "name": "special",
      "fee": 0,
      "message": ""
      }
      ],
      "totalFees": 3000,
      "message": "",
      "title": "Delivery Charge",
      "amount": "3000",
      "icon": ""
      },
      "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
      },
      "longDistanceEnabled": 0,
      "rainMode": "NONE",
      "thirdPartyAddress": false,
      "thirdPartyVendor": "",
      "adTrackingID": "",
      "badges": {
      "imageBased": [],
      "textBased": [],
      "textExtendedBadges": []
      },
      "lastMileTravelString": "1.1 kms",
      "hasSurge": false,
      "aggregatedDiscountInfoV3": {
      "header": "20% OFF",
      "subHeader": "UPTO ₹50",
      "discountTag": "",
      "headerTypeV2": 0
      },
      "sla": {
      "restaurantId": "256960",
      "deliveryTime": 18,
      "minDeliveryTime": 18,
      "maxDeliveryTime": 18,
      "lastMileTravel": 1.100000023841858,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
      },
      "promoted": false,
      "avgRating": "4.0",
      "totalRatings": 1000,
      "new": false
      },
      "subtype": "basic"
      },
      "parentWidget": false
      },
      {
      "cardType": "restaurant",
      "layoutAlignmentType": "VERTICAL",
      "data": {
      "type": "restaurant",
      "data": {
      "type": "F",
      "id": "661733",
      "name": "Narmada Chain Of Restaurant",
      "uuid": "4ee8d991-fefd-4a65-ac54-7da7fcbbfbf1",
      "city": "1",
      "area": "Kadubeesanahalli",
      "totalRatingsString": "1000+ ratings",
      "cloudinaryImageId": "3bf711cdef6072ae50c099c7e353497e",
      "cuisines": [
      "Biryani",
      "Andhra",
      "South Indian"
      ],
      "tags": [],
      "costForTwo": 50000,
      "costForTwoString": "₹500 FOR TWO",
      "deliveryTime": 32,
      "minDeliveryTime": 32,
      "maxDeliveryTime": 32,
      "slaString": "32 MINS",
      "lastMileTravel": 5.599999904632568,
      "slugs": {
      "restaurant": "narmada-chain-of-restaurant-kadubeesanahalli-kadubeesanahalli",
      "city": "bangalore"
      },
      "cityState": "1",
      "address": "No.88, Outer Ring Road, Opp. More Mega Store, Marathahalli, Bengaluru-560037",
      "locality": "Ring Road",
      "parentId": 322826,
      "unserviceable": false,
      "veg": false,
      "select": false,
      "favorite": false,
      "tradeCampaignHeaders": [],
      "chain": [],
      "feeDetails": {
      "fees": [
      {
      "name": "distance",
      "fee": 5500,
      "message": ""
      },
      {
      "name": "time",
      "fee": 0,
      "message": ""
      },
      {
      "name": "special",
      "fee": 0,
      "message": ""
      }
      ],
      "totalFees": 5500,
      "message": "",
      "title": "Delivery Charge",
      "amount": "5500",
      "icon": ""
      },
      "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
      },
      "longDistanceEnabled": 0,
      "rainMode": "NONE",
      "thirdPartyAddress": false,
      "thirdPartyVendor": "",
      "adTrackingID": "",
      "badges": {
      "imageBased": [],
      "textBased": [],
      "textExtendedBadges": []
      },
      "lastMileTravelString": "5.5 kms",
      "hasSurge": false,
      "aggregatedDiscountInfoV3": {
      "header": "10% OFF",
      "subHeader": "UPTO ₹40",
      "discountTag": "",
      "headerTypeV2": 0
      },
      "sla": {
      "restaurantId": "661733",
      "deliveryTime": 32,
      "minDeliveryTime": 32,
      "maxDeliveryTime": 32,
      "lastMileTravel": 5.599999904632568,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
      },
      "promoted": false,
      "avgRating": "4.3",
      "totalRatings": 1000,
      "new": false
      },
      "subtype": "basic"
      },
      "parentWidget": false
      },
      {
      "cardType": "restaurant",
      "layoutAlignmentType": "VERTICAL",
      "data": {
      "type": "restaurant",
      "data": {
      "type": "F",
      "id": "679413",
      "name": "Easy Bites By Empire",
      "uuid": "8d2e1ef9-778f-488d-9cc4-d55c3d066270",
      "city": "1",
      "area": "Mahadevpura",
      "totalRatingsString": "500+ ratings",
      "cloudinaryImageId": "3607a6af73ba20341a09eaf46a111f52",
      "cuisines": [
      "Snacks",
      "Fast Food",
      "Beverages"
      ],
      "tags": [],
      "costForTwo": 20000,
      "costForTwoString": "₹200 FOR TWO",
      "deliveryTime": 43,
      "minDeliveryTime": 43,
      "maxDeliveryTime": 43,
      "slaString": "43 MINS",
      "lastMileTravel": 7.5,
      "slugs": {
      "restaurant": "easy-bites-by-empire-mahadevpura-mahadevpura",
      "city": "bangalore"
      },
      "cityState": "1",
      "address": "MUNICIPAL NO.53/2, SL NO.319, DODDAKANNELLI VILLAGE, VARTHUR HOBLI, BANGALORE., Mahadevapura , B.B.M.P East, Karnataka, 560035",
      "locality": "Varthur",
      "parentId": 393168,
      "unserviceable": false,
      "veg": false,
      "select": false,
      "favorite": false,
      "tradeCampaignHeaders": [],
      "chain": [],
      "feeDetails": {
      "fees": [
      {
      "name": "distance",
      "fee": 7100,
      "message": ""
      },
      {
      "name": "time",
      "fee": 0,
      "message": ""
      },
      {
      "name": "special",
      "fee": 0,
      "message": ""
      }
      ],
      "totalFees": 7100,
      "message": "",
      "title": "Delivery Charge",
      "amount": "7100",
      "icon": ""
      },
      "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
      },
      "longDistanceEnabled": 0,
      "rainMode": "NONE",
      "thirdPartyAddress": false,
      "thirdPartyVendor": "",
      "adTrackingID": "",
      "badges": {
      "imageBased": [],
      "textBased": [],
      "textExtendedBadges": []
      },
      "lastMileTravelString": "7.5 kms",
      "hasSurge": false,
      "aggregatedDiscountInfoV3": {
      "header": "10% OFF",
      "subHeader": "UPTO ₹40",
      "discountTag": "",
      "headerTypeV2": 0
      },
      "sla": {
      "restaurantId": "679413",
      "deliveryTime": 43,
      "minDeliveryTime": 43,
      "maxDeliveryTime": 43,
      "lastMileTravel": 7.5,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
      },
      "promoted": false,
      "avgRating": "4.1",
      "totalRatings": 500,
      "new": false
      },
      "subtype": "basic"
      },
      "parentWidget": false
      },
      {
      "cardType": "restaurant",
      "layoutAlignmentType": "VERTICAL",
      "data": {
      "type": "restaurant",
      "data": {
      "type": "F",
      "id": "136193",
      "name": "Kabab Souq",
      "uuid": "1be8762f-6839-4640-a823-8fef41239aca",
      "city": "1",
      "area": "Kaggadasapura",
      "totalRatingsString": "1000+ ratings",
      "cloudinaryImageId": "intyfalqayh6ueqssb9c",
      "cuisines": [
      "Chinese",
      "Arabian"
      ],
      "tags": [],
      "costForTwo": 20000,
      "costForTwoString": "₹200 FOR TWO",
      "deliveryTime": 30,
      "minDeliveryTime": 30,
      "maxDeliveryTime": 30,
      "slaString": "30 MINS",
      "lastMileTravel": 5,
      "slugs": {
      "restaurant": "kabab-souq-test-prod-area",
      "city": "bangalore"
      },
      "cityState": "1",
      "address": "No. 5, JM Complex, Kempanna Main Rd, 1st Block, Vignan Nagar, LBS Nagar, Kaggadasapura, Bengaluru, Karnataka 560037",
      "locality": "Vignan Nagar",
      "parentId": 21331,
      "unserviceable": false,
      "veg": false,
      "select": false,
      "favorite": false,
      "tradeCampaignHeaders": [],
      "chain": [],
      "feeDetails": {
      "fees": [
      {
      "name": "distance",
      "fee": 5500,
      "message": ""
      },
      {
      "name": "time",
      "fee": 0,
      "message": ""
      },
      {
      "name": "special",
      "fee": 0,
      "message": ""
      }
      ],
      "totalFees": 5500,
      "message": "",
      "title": "Delivery Charge",
      "amount": "5500",
      "icon": ""
      },
      "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
      },
      "longDistanceEnabled": 0,
      "rainMode": "NONE",
      "thirdPartyAddress": false,
      "thirdPartyVendor": "",
      "adTrackingID": "",
      "badges": {
      "imageBased": [],
      "textBased": [],
      "textExtendedBadges": []
      },
      "lastMileTravelString": "5 kms",
      "hasSurge": false,
      "aggregatedDiscountInfoV3": {
      "header": "10% OFF",
      "subHeader": "UPTO ₹40",
      "discountTag": "",
      "headerTypeV2": 0
      },
      "sla": {
      "restaurantId": "136193",
      "deliveryTime": 30,
      "minDeliveryTime": 30,
      "maxDeliveryTime": 30,
      "lastMileTravel": 5,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
      },
      "promoted": false,
      "avgRating": "4.0",
      "totalRatings": 1000,
      "new": false
      },
      "subtype": "basic"
      },
      "parentWidget": false
      },
      {
      "cardType": "restaurant",
      "layoutAlignmentType": "VERTICAL",
      "data": {
      "type": "restaurant",
      "data": {
      "type": "F",
      "id": "18976",
      "name": "Nandhana Palace",
      "uuid": "ea8e804f-6236-45eb-9dfe-f14d14c8ec0a",
      "city": "1",
      "area": "Marathahalli",
      "totalRatingsString": "10000+ ratings",
      "cloudinaryImageId": "goy1hl2aaipbblqjpxe3",
      "cuisines": [
      "Biryani",
      "Andhra",
      "South Indian",
      "North Indian"
      ],
      "tags": [],
      "costForTwo": 50000,
      "costForTwoString": "₹500 FOR TWO",
      "deliveryTime": 35,
      "minDeliveryTime": 35,
      "maxDeliveryTime": 35,
      "slaString": "35 MINS",
      "lastMileTravel": 5.699999809265137,
      "slugs": {
      "restaurant": "nandhana-palace-marathahalli-mahadevpura",
      "city": "bangalore"
      },
      "cityState": "1",
      "address": "Nandhana Palace,#1,Diagonally Opp. To Multiplex/@Home, Marthahalli Outer Ring Road,Munnekolal,Bangalore560037",
      "locality": "Munnekollal",
      "parentId": 2120,
      "unserviceable": false,
      "veg": false,
      "select": false,
      "favorite": false,
      "tradeCampaignHeaders": [],
      "chain": [],
      "feeDetails": {
      "fees": [
      {
      "name": "distance",
      "fee": 5500,
      "message": ""
      },
      {
      "name": "time",
      "fee": 0,
      "message": ""
      },
      {
      "name": "special",
      "fee": 0,
      "message": ""
      }
      ],
      "totalFees": 5500,
      "message": "",
      "title": "Delivery Charge",
      "amount": "5500",
      "icon": ""
      },
      "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
      },
      "longDistanceEnabled": 0,
      "rainMode": "NONE",
      "thirdPartyAddress": false,
      "thirdPartyVendor": "",
      "adTrackingID": "",
      "badges": {
      "imageBased": [],
      "textBased": [],
      "textExtendedBadges": []
      },
      "lastMileTravelString": "5.6 kms",
      "hasSurge": false,
      "sla": {
      "restaurantId": "18976",
      "deliveryTime": 35,
      "minDeliveryTime": 35,
      "maxDeliveryTime": 35,
      "lastMileTravel": 5.699999809265137,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
      },
      "promoted": false,
      "avgRating": "4.2",
      "totalRatings": 10000,
      "new": false
      },
      "subtype": "basic"
      },
      "parentWidget": false
      },
      {
      "cardType": "restaurant",
      "layoutAlignmentType": "VERTICAL",
      "data": {
      "type": "restaurant",
      "data": {
      "type": "F",
      "id": "402132",
      "name": "Udupi Gokula Veg",
      "uuid": "8099761d-ef32-4dcf-972f-b651ff065e83",
      "city": "1",
      "area": "KR Puram",
      "totalRatingsString": "1000+ ratings",
      "cloudinaryImageId": "wplrmo25ipisxvrta6hg",
      "cuisines": [
      "South Indian",
      "Chinese",
      "Beverages"
      ],
      "tags": [],
      "costForTwo": 20000,
      "costForTwoString": "₹200 FOR TWO",
      "deliveryTime": 32,
      "minDeliveryTime": 32,
      "maxDeliveryTime": 32,
      "slaString": "32 MINS",
      "lastMileTravel": 6,
      "slugs": {
      "restaurant": "udupi-gokula-veg-battarahalli-battarahalli",
      "city": "bangalore"
      },
      "cityState": "1",
      "address": "1, 3rd Main Rd, Bethel Nagar, Krishnarajapura, Bengaluru, Karnataka 560049, India",
      "locality": "Bethel Nagar",
      "parentId": 258497,
      "unserviceable": false,
      "veg": true,
      "select": false,
      "favorite": false,
      "tradeCampaignHeaders": [],
      "chain": [],
      "feeDetails": {
      "fees": [
      {
      "name": "distance",
      "fee": 6300,
      "message": ""
      },
      {
      "name": "time",
      "fee": 0,
      "message": ""
      },
      {
      "name": "special",
      "fee": 0,
      "message": ""
      }
      ],
      "totalFees": 6300,
      "message": "",
      "title": "Delivery Charge",
      "amount": "6300",
      "icon": ""
      },
      "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
      },
      "longDistanceEnabled": 0,
      "rainMode": "NONE",
      "thirdPartyAddress": false,
      "thirdPartyVendor": "",
      "adTrackingID": "",
      "badges": {
      "imageBased": [],
      "textBased": [],
      "textExtendedBadges": []
      },
      "lastMileTravelString": "6 kms",
      "hasSurge": false,
      "sla": {
      "restaurantId": "402132",
      "deliveryTime": 32,
      "minDeliveryTime": 32,
      "maxDeliveryTime": 32,
      "lastMileTravel": 6,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
      },
      "promoted": false,
      "avgRating": "4.1",
      "totalRatings": 1000,
      "new": false
      },
      "subtype": "basic"
      },
      "parentWidget": false
      },
      {
      "cardType": "restaurant",
      "layoutAlignmentType": "VERTICAL",
      "data": {
      "type": "restaurant",
      "data": {
      "type": "F",
      "id": "57366",
      "name": "Sri lakshmi Vaibhav",
      "uuid": "62c71c2d-b7a0-4ba1-a4a4-4ad9eb11612d",
      "city": "1",
      "area": "Marathahalli",
      "totalRatingsString": "10000+ ratings",
      "cloudinaryImageId": "u9xukrvrqisiaxy5plop",
      "cuisines": [
      "Chinese",
      "Jain",
      "North Indian",
      "South Indian",
      "Sweets"
      ],
      "tags": [],
      "costForTwo": 30000,
      "costForTwoString": "₹300 FOR TWO",
      "deliveryTime": 27,
      "minDeliveryTime": 27,
      "maxDeliveryTime": 27,
      "slaString": "27 MINS",
      "lastMileTravel": 3,
      "slugs": {
      "restaurant": "sri-lakshmi-vaibhav-marathahalli-marathahalli",
      "city": "bangalore"
      },
      "cityState": "1",
      "address": "96, SHIRDI SAI LAYOUT, MUNNEKOLALA VILLAGE, Karnataka, 560037",
      "locality": "Munnekollal",
      "parentId": 7662,
      "unserviceable": false,
      "veg": true,
      "select": false,
      "favorite": false,
      "tradeCampaignHeaders": [],
      "chain": [],
      "feeDetails": {
      "fees": [
      {
      "name": "distance",
      "fee": 4000,
      "message": ""
      },
      {
      "name": "time",
      "fee": 0,
      "message": ""
      },
      {
      "name": "special",
      "fee": 0,
      "message": ""
      }
      ],
      "totalFees": 4000,
      "message": "",
      "title": "Delivery Charge",
      "amount": "4000",
      "icon": ""
      },
      "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
      },
      "longDistanceEnabled": 0,
      "rainMode": "NONE",
      "thirdPartyAddress": false,
      "thirdPartyVendor": "",
      "adTrackingID": "",
      "badges": {
      "imageBased": [],
      "textBased": [],
      "textExtendedBadges": []
      },
      "lastMileTravelString": "3 kms",
      "hasSurge": false,
      "sla": {
      "restaurantId": "57366",
      "deliveryTime": 27,
      "minDeliveryTime": 27,
      "maxDeliveryTime": 27,
      "lastMileTravel": 3,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
      },
      "promoted": false,
      "avgRating": "4.4",
      "totalRatings": 10000,
      "new": false
      },
      "subtype": "basic"
      },
      "parentWidget": false
      },
      {
      "cardType": "restaurant",
      "layoutAlignmentType": "VERTICAL",
      "data": {
      "type": "restaurant",
      "data": {
      "type": "F",
      "id": "51855",
      "name": "Damodar Seth - Bengali Cuisine",
      "uuid": "8e6fdff4-4763-41aa-83e1-8469dd050e13",
      "city": "1",
      "area": "Marathahalli",
      "totalRatingsString": "10000+ ratings",
      "cloudinaryImageId": "dxxon9kxq0btpd4azfhy",
      "cuisines": [
      "Bengali",
      "Chinese",
      "North Indian",
      "Tandoor",
      "Thalis",
      "Desserts"
      ],
      "tags": [],
      "costForTwo": 19900,
      "costForTwoString": "₹199 FOR TWO",
      "deliveryTime": 26,
      "minDeliveryTime": 26,
      "maxDeliveryTime": 26,
      "slaString": "26 MINS",
      "lastMileTravel": 2.799999952316284,
      "slugs": {
      "restaurant": "damodar-seth-marathahalli-marathahalli",
      "city": "bangalore"
      },
      "cityState": "1",
      "address": "#110, Damodar seth, 2nd main, 5th cross, aswathnagar, Marathahalli, Bangalore-37",
      "locality": "Aswath Nagar",
      "parentId": 14577,
      "unserviceable": false,
      "veg": false,
      "select": false,
      "favorite": false,
      "tradeCampaignHeaders": [],
      "chain": [],
      "feeDetails": {
      "fees": [
      {
      "name": "distance",
      "fee": 3000,
      "message": ""
      },
      {
      "name": "time",
      "fee": 0,
      "message": ""
      },
      {
      "name": "special",
      "fee": 0,
      "message": ""
      }
      ],
      "totalFees": 3000,
      "message": "",
      "title": "Delivery Charge",
      "amount": "3000",
      "icon": ""
      },
      "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
      },
      "longDistanceEnabled": 0,
      "rainMode": "NONE",
      "thirdPartyAddress": false,
      "thirdPartyVendor": "",
      "adTrackingID": "",
      "badges": {
      "imageBased": [],
      "textBased": [],
      "textExtendedBadges": []
      },
      "lastMileTravelString": "2.7 kms",
      "hasSurge": false,
      "aggregatedDiscountInfoV3": {
      "header": "50% OFF",
      "subHeader": "UPTO ₹100",
      "discountTag": "",
      "headerTypeV2": 0
      },
      "sla": {
      "restaurantId": "51855",
      "deliveryTime": 26,
      "minDeliveryTime": 26,
      "maxDeliveryTime": 26,
      "lastMileTravel": 2.799999952316284,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
      },
      "promoted": false,
      "avgRating": "3.7",
      "totalRatings": 10000,
      "new": false
      },
      "subtype": "basic"
      },
      "parentWidget": false
      },
      {
      "cardType": "restaurant",
      "layoutAlignmentType": "VERTICAL",
      "data": {
      "type": "restaurant",
      "data": {
      "type": "F",
      "id": "161429",
      "name": "Sri Udupi Sannidhi",
      "uuid": "8b87483b-0c21-418b-a56d-340465633ae6",
      "city": "1",
      "area": "Mahadevpura",
      "totalRatingsString": "10000+ ratings",
      "cloudinaryImageId": "b6c0620fe9f64ed2116cfd06dd19a354",
      "cuisines": [
      "South Indian",
      "North Indian",
      "Chinese",
      "Juices",
      "Chaat",
      "Ice Cream"
      ],
      "tags": [],
      "costForTwo": 15000,
      "costForTwoString": "₹150 FOR TWO",
      "deliveryTime": 29,
      "minDeliveryTime": 29,
      "maxDeliveryTime": 29,
      "slaString": "29 MINS",
      "lastMileTravel": 4.300000190734863,
      "slugs": {
      "restaurant": "sri-udupi-sannidhi-mahadevpura",
      "city": "bangalore"
      },
      "cityState": "1",
      "address": "Geetha Towers, A24, Kamadhenu Nagar,  Outer ring road, Near skoda showroom, B Narayanapura, Bangalore 560016",
      "locality": "B Narayanapura",
      "parentId": 20968,
      "unserviceable": false,
      "veg": true,
      "select": false,
      "favorite": false,
      "tradeCampaignHeaders": [],
      "chain": [],
      "feeDetails": {
      "fees": [
      {
      "name": "distance",
      "fee": 4000,
      "message": ""
      },
      {
      "name": "time",
      "fee": 0,
      "message": ""
      },
      {
      "name": "special",
      "fee": 0,
      "message": ""
      }
      ],
      "totalFees": 4000,
      "message": "",
      "title": "Delivery Charge",
      "amount": "4000",
      "icon": ""
      },
      "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
      },
      "longDistanceEnabled": 0,
      "rainMode": "NONE",
      "thirdPartyAddress": false,
      "thirdPartyVendor": "",
      "adTrackingID": "",
      "badges": {
      "imageBased": [],
      "textBased": [],
      "textExtendedBadges": []
      },
      "lastMileTravelString": "4.3 kms",
      "hasSurge": false,
      "aggregatedDiscountInfoV3": {
      "header": "30% OFF",
      "subHeader": "UPTO ₹75",
      "discountTag": "",
      "headerTypeV2": 0
      },
      "sla": {
      "restaurantId": "161429",
      "deliveryTime": 29,
      "minDeliveryTime": 29,
      "maxDeliveryTime": 29,
      "lastMileTravel": 4.300000190734863,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
      },
      "promoted": false,
      "avgRating": "3.9",
      "totalRatings": 10000,
      "new": false
      },
      "subtype": "basic"
      },
      "parentWidget": false
      },
      {
      "cardType": "restaurant",
      "layoutAlignmentType": "VERTICAL",
      "data": {
      "type": "restaurant",
      "data": {
      "type": "F",
      "id": "680996",
      "name": "Village Biryani",
      "uuid": "339a2075-f2b8-4d31-9c0d-27fa041880ac",
      "city": "1",
      "area": "Kadubeesanahalli",
      "totalRatingsString": "100+ ratings",
      "cloudinaryImageId": "a0192c837933561adfd8fc23ad06daaa",
      "cuisines": [
      "Biryani",
      "North Indian",
      "South Indian",
      "Snacks"
      ],
      "tags": [],
      "costForTwo": 30000,
      "costForTwoString": "₹300 FOR TWO",
      "deliveryTime": 30,
      "minDeliveryTime": 30,
      "maxDeliveryTime": 30,
      "slaString": "30 MINS",
      "lastMileTravel": 4.400000095367432,
      "slugs": {
      "restaurant": "village-biryani-kadubeesanahalli-kadubeesanahalli",
      "city": "bangalore"
      },
      "cityState": "1",
      "address": "NO 15, VIVEKANANDA LAYOUT, NEAR BIRYANI ZONE, MUNNEKOLALA, MARATHAHALLI, BANGALORE,B.B.M.P East,Karnataka,560037",
      "locality": "Chandra Layout",
      "parentId": 406828,
      "unserviceable": false,
      "veg": false,
      "select": false,
      "favorite": false,
      "tradeCampaignHeaders": [],
      "chain": [],
      "feeDetails": {
      "fees": [
      {
      "name": "distance",
      "fee": 4000,
      "message": ""
      },
      {
      "name": "time",
      "fee": 0,
      "message": ""
      },
      {
      "name": "special",
      "fee": 0,
      "message": ""
      }
      ],
      "totalFees": 4000,
      "message": "",
      "title": "Delivery Charge",
      "amount": "4000",
      "icon": ""
      },
      "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
      },
      "longDistanceEnabled": 0,
      "rainMode": "NONE",
      "thirdPartyAddress": false,
      "thirdPartyVendor": "",
      "adTrackingID": "",
      "badges": {
      "imageBased": [],
      "textBased": [],
      "textExtendedBadges": []
      },
      "lastMileTravelString": "4.4 kms",
      "hasSurge": false,
      "aggregatedDiscountInfoV3": {
      "header": "20% OFF",
      "subHeader": "UPTO ₹50",
      "discountTag": "",
      "headerTypeV2": 0
      },
      "sla": {
      "restaurantId": "680996",
      "deliveryTime": 30,
      "minDeliveryTime": 30,
      "maxDeliveryTime": 30,
      "lastMileTravel": 4.400000095367432,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
      },
      "promoted": false,
      "avgRating": "4.0",
      "totalRatings": 100,
      "new": false
      },
      "subtype": "basic"
      },
      "parentWidget": false
      },
      {
      "cardType": "restaurant",
      "layoutAlignmentType": "VERTICAL",
      "data": {
      "type": "restaurant",
      "data": {
      "type": "F",
      "id": "214427",
      "name": "CakeZone",
      "uuid": "870c7347-2afa-4e32-8aa6-d24142dd880f",
      "city": "1",
      "area": "Nallurhalli",
      "totalRatingsString": "10000+ ratings",
      "cloudinaryImageId": "a6b6cf549e01de61b9c415e936ff4511",
      "cuisines": [
      "Bakery",
      "Desserts",
      "Sweets",
      "Ice Cream"
      ],
      "tags": [],
      "costForTwo": 20000,
      "costForTwoString": "₹200 FOR TWO",
      "deliveryTime": 40,
      "minDeliveryTime": 40,
      "maxDeliveryTime": 40,
      "slaString": "40 MINS",
      "lastMileTravel": 4.599999904632568,
      "slugs": {
      "restaurant": "cakezone-whitefield-whitefield",
      "city": "bangalore"
      },
      "cityState": "1",
      "address": "90, Nallurhalli, Whitefield, Bengaluru, Karnataka 560066, India",
      "locality": "Nallurhalli",
      "parentId": 7003,
      "unserviceable": false,
      "veg": false,
      "select": false,
      "favorite": false,
      "tradeCampaignHeaders": [],
      "chain": [],
      "feeDetails": {
      "fees": [
      {
      "name": "distance",
      "fee": 4000,
      "message": ""
      },
      {
      "name": "time",
      "fee": 0,
      "message": ""
      },
      {
      "name": "special",
      "fee": 0,
      "message": ""
      }
      ],
      "totalFees": 4000,
      "message": "",
      "title": "Delivery Charge",
      "amount": "4000",
      "icon": ""
      },
      "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
      },
      "longDistanceEnabled": 0,
      "rainMode": "NONE",
      "thirdPartyAddress": false,
      "thirdPartyVendor": "",
      "adTrackingID": "",
      "badges": {
      "imageBased": [],
      "textBased": [],
      "textExtendedBadges": []
      },
      "lastMileTravelString": "4.5 kms",
      "hasSurge": false,
      "aggregatedDiscountInfoV3": {
      "header": "20% OFF",
      "subHeader": "ABOVE ₹800",
      "discountTag": "FLAT DEAL",
      "headerTypeV2": 0
      },
      "sla": {
      "restaurantId": "214427",
      "deliveryTime": 40,
      "minDeliveryTime": 40,
      "maxDeliveryTime": 40,
      "lastMileTravel": 4.599999904632568,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
      },
      "promoted": false,
      "avgRating": "4.4",
      "totalRatings": 10000,
      "new": false
      },
      "subtype": "basic"
      },
      "parentWidget": false
      },
      {
      "cardType": "restaurant",
      "layoutAlignmentType": "VERTICAL",
      "data": {
      "type": "restaurant",
      "data": {
      "type": "F",
      "id": "6911",
      "name": "FreshMenu",
      "uuid": "eb725d30-eb2c-4c90-bc2d-e174c729a1af",
      "city": "1",
      "area": "Marathahalli",
      "totalRatingsString": "10000+ ratings",
      "cloudinaryImageId": "6c4de7b481d3614370e5062b2f33e7d6",
      "cuisines": [
      "Continental",
      "Chinese",
      "Oriental",
      "Asian",
      "Healthy Food",
      "Fast Food",
      "Indian",
      "Desserts"
      ],
      "tags": [],
      "costForTwo": 25000,
      "costForTwoString": "₹250 FOR TWO",
      "deliveryTime": 33,
      "minDeliveryTime": 33,
      "maxDeliveryTime": 33,
      "slaString": "33 MINS",
      "lastMileTravel": 4.300000190734863,
      "slugs": {
      "restaurant": "freshmenu-varthur-main-road-marathahalli",
      "city": "bangalore"
      },
      "cityState": "1",
      "address": "#2, Sai Towers, 3rd floor, Gulmohar road, Next to Krituga, Near Star bazar, Marathahalli, Bangalore",
      "locality": "Gulmohar road",
      "parentId": 398,
      "unserviceable": false,
      "veg": false,
      "select": false,
      "favorite": false,
      "tradeCampaignHeaders": [],
      "chain": [],
      "feeDetails": {
      "fees": [
      {
      "name": "distance",
      "fee": 4000,
      "message": ""
      },
      {
      "name": "time",
      "fee": 0,
      "message": ""
      },
      {
      "name": "special",
      "fee": 0,
      "message": ""
      }
      ],
      "totalFees": 4000,
      "message": "",
      "title": "Delivery Charge",
      "amount": "4000",
      "icon": ""
      },
      "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
      },
      "longDistanceEnabled": 0,
      "rainMode": "NONE",
      "thirdPartyAddress": false,
      "thirdPartyVendor": "",
      "adTrackingID": "",
      "badges": {
      "imageBased": [],
      "textBased": [],
      "textExtendedBadges": []
      },
      "lastMileTravelString": "4.3 kms",
      "hasSurge": false,
      "aggregatedDiscountInfoV3": {
      "header": "EVERY ITEM",
      "subHeader": "@ ₹149",
      "discountTag": "",
      "headerTypeV2": 0
      },
      "sla": {
      "restaurantId": "6911",
      "deliveryTime": 33,
      "minDeliveryTime": 33,
      "maxDeliveryTime": 33,
      "lastMileTravel": 4.300000190734863,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
      },
      "promoted": false,
      "avgRating": "3.9",
      "totalRatings": 10000,
      "new": false
      },
      "subtype": "basic"
      },
      "parentWidget": false
      },
      {
      "cardType": "restaurant",
      "layoutAlignmentType": "VERTICAL",
      "data": {
      "type": "restaurant",
      "data": {
      "type": "F",
      "id": "187172",
      "name": "New Udupi Garden Veg",
      "uuid": "6061b3f4-e3b7-4690-bf0b-4137b65bb904",
      "city": "1",
      "area": "KR Puram",
      "totalRatingsString": "5000+ ratings",
      "cloudinaryImageId": "nbrs8ehmlcdmbv4ga0qs",
      "cuisines": [
      "Chaat",
      "Chinese",
      "Fast Food",
      "Juices",
      "North Indian",
      "South Indian"
      ],
      "tags": [],
      "costForTwo": 20000,
      "costForTwoString": "₹200 FOR TWO",
      "deliveryTime": 33,
      "minDeliveryTime": 33,
      "maxDeliveryTime": 33,
      "slaString": "33 MINS",
      "lastMileTravel": 7.199999809265137,
      "slugs": {
      "restaurant": "new-udupi-garden-veg-battarahalli-battarahalli",
      "city": "bangalore"
      },
      "cityState": "1",
      "address": "New Udupi Garden Veg, Basavanapura Main Rd, Chikkabasavanapura, Krishnarajapura, Bengaluru, Karnataka, India",
      "locality": "Basavanapura Main Road",
      "parentId": 21258,
      "unserviceable": false,
      "veg": true,
      "select": false,
      "favorite": false,
      "tradeCampaignHeaders": [],
      "chain": [],
      "feeDetails": {
      "fees": [
      {
      "name": "distance",
      "fee": 7100,
      "message": ""
      },
      {
      "name": "time",
      "fee": 0,
      "message": ""
      },
      {
      "name": "special",
      "fee": 0,
      "message": ""
      }
      ],
      "totalFees": 7100,
      "message": "",
      "title": "Delivery Charge",
      "amount": "7100",
      "icon": ""
      },
      "availability": {
      "opened": true,
      "nextOpenMessage": "",
      "nextCloseMessage": ""
      },
      "longDistanceEnabled": 0,
      "rainMode": "NONE",
      "thirdPartyAddress": false,
      "thirdPartyVendor": "",
      "adTrackingID": "",
      "badges": {
      "imageBased": [],
      "textBased": [],
      "textExtendedBadges": []
      },
      "lastMileTravelString": "7.1 kms",
      "hasSurge": false,
      "sla": {
      "restaurantId": "187172",
      "deliveryTime": 33,
      "minDeliveryTime": 33,
      "maxDeliveryTime": 33,
      "lastMileTravel": 7.199999809265137,
      "lastMileDistance": 0,
      "serviceability": "SERVICEABLE",
      "rainMode": "NONE",
      "longDistance": "NOT_LONG_DISTANCE",
      "preferentialService": false,
      "iconType": "EMPTY"
      },
      "promoted": false,
      "avgRating": "4.0",
      "totalRatings": 5000,
      "new": false
      },
      "subtype": "basic"
      },
      "parentWidget": false
      }
      ],
      "nextPageFetch": "0",
      },
      "tid": "20accd0d-1619-48a2-aa35-6fb179e5add6",
      "sid": "7nv0f848-ee04-4ec4-acc2-efe3bd7bb2ff",
      "deviceId": "e140ee10-50e7-10db-7831-10947e3bbbf5",
      "csrfToken": "2BfW7HZeJhP2-XURW6xHZ91_3k6F-EBxXhm1B6FI",
      }
  ;
